import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import useDataverseService from "../../services/DataverseService";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import { useSelectedEntity } from "../Contexts/SelectedEntityProvider";
import { useAssignment } from "../hooks/useAssignment";
import "./AssignMenu.css";

interface AssignMenuProps {
  x: number;
  y: number;
  onDismiss: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignMenu = (props: AssignMenuProps) => {
  const { instance } = useMsal();
  const { getUsers, fetchData } = useDataverseService();
  const { selectedEntity } = useSelectedEntity();
  const [users, setUsers] = useState<any[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any | null>(null);
  const [allRecordsSelected, setAllRecordsSelected] = useState<boolean>(false);

  const { assignUser } = useAssignment();

  useEffect(() => {
    const fetchUsers = async () => {
      const usersList = await getUsers();
      setUsers(usersList);

      const currentUser = usersList.find((u: any) =>
        u.firstname === "#"
          ? u.fullname.replace(/^# /, "") === instance.getActiveAccount()?.name
          : u.fullname === instance.getActiveAccount()?.name
      );

      const owners: any = await fetchData("new_entityowners");

      const isCurrentUserOwner =
        selectedEntity?._ownerid_value === currentUser.systemuserid;

      if (isCurrentUserOwner) {
        setUsers(usersList);
      } else {
        const selectedTableOwner = owners.data.value.find(
          (o: any) => o._ownerid_value === selectedEntity?._ownerid_value
        );

        if (selectedTableOwner) {
          const filteredUsersList = usersList.filter(
            (u: any) => u.systemuserid === selectedTableOwner._ownerid_value
          );
          setUsers(filteredUsersList);
        }
      }
    };

    fetchUsers();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setFilteredUsers(
      users.filter((user) =>
        user.fullname.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleUserSelect = (user: any) => {
    setSelectedUser(user);
    setInputValue(user.displayName);
    setFilteredUsers([]);
  };

  const getInitials = (name: string) => {
    const initials = name
      .split(" ")
      .map((word) => word[0])
      .join("");
    return initials.toUpperCase();
  };

  return (
    <div
      className="assignMenu"
      style={{ top: props.y, left: props.x }}
      onClick={(e: any) => e.stopPropagation()}
    >
      <div className="assignHeader">
        Assign to
        <img
          style={{ cursor: "pointer" }}
          src="Dismiss.png"
          alt="dismiss"
          height={"16px"}
          onClick={() => props.onDismiss(false)}
        />
      </div>
      <input
        className="assignInput"
        placeholder="Search..."
        value={inputValue}
        onChange={handleInputChange}
      />
      {filteredUsers.length > 0 && (
        <div className="assignDropdown">
          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className="assignDropdownItem"
              onClick={() => handleUserSelect(user)}
            >
              <span>{user.fullname}</span>
              <span className="personPosition">{user.title}</span>
            </div>
          ))}
        </div>
      )}
      {selectedUser && (
        <>
          <div className="assignPerson">
            <div className="initialCircle">
              {getInitials(selectedUser.fullname)}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{selectedUser.fullname}</span>
              <span className="personPosition">{selectedUser.title}</span>
            </div>
          </div>
        </>
      )}
      <div className="assignCheckboxContainer">
        <div className="assignCheckbox">
          <input
            type="checkbox"
            className="box"
            id="allRecords"
            checked={allRecordsSelected}
            onChange={() => setAllRecordsSelected(true)}
          />
          <label htmlFor="allRecords">All records</label>
        </div>
        <div className="assignCheckbox">
          <input
            type="checkbox"
            className="box"
            id="selectedRecords"
            checked={!allRecordsSelected}
            onChange={() => setAllRecordsSelected(false)}
          />
          <label htmlFor="selectedRecords">Selected records</label>
        </div>
      </div>
      <div className="assignButton">
        <ButtonComponent
          name="Assign"
          selected={"Assign"}
          isDisabled={!selectedUser}
          onClick={
            selectedUser
              ? () => {
                  assignUser(
                    selectedUser,
                    allRecordsSelected,
                    props.setLoading
                  );
                  props.onDismiss(false);
                  setAllRecordsSelected(false);
                }
              : () => {}
          }
        />
      </div>
    </div>
  );
};

export default AssignMenu;
